import * as React from "react";
import Select from "react-select";
import ValidateError from "./ValidateError";

interface ValidateSelectProps {
  tabIndex?: string;
  className?: string;
  name: string;
  onChange: Function;
  onKeyDown?: React.KeyboardEventHandler<{}>;
  inputValue: string;
  placeholder?: string;
  type?: string;
  input?: any;
  clearable?: boolean;
  meta?: any;
  label?: string;
  options?: any;
  id?: string;
  getRef?: Function;
  _onFocus?: Function;
  valueKey?: string;
}

const getValue = (inputValue, value) => {
  if (inputValue !== "") {
    return inputValue;
  }

  return value;
};

export default class ValidateSelect extends React.Component<
  ValidateSelectProps,
  any
> {
  public static defaultProps = {
    type: "text",
    label: "",
    className: "form-control--select",
  };

  constructor(props) {
    super(props);

    this.ref = this.ref.bind(this);
  }

  ref(input) {
    if (this.props.getRef) {
      this.props.getRef(input);
    }
  }

  render() {
    const input = this.props.input;
    const meta = this.props.meta;

    const value = getValue(this.props.inputValue, this.props.input.value);
    const errorClassName = this.props.className.split(" ").pop();

    return (
      <div id={this.props.id}>
        <Select
          tabIndex={this.props.tabIndex}
          ref={input => this.ref(input)}
          name={this.props.name}
          className={this.props.className}
          onBlur={() => {
            if (this.props.valueKey) {
              input.onBlur(input.value[this.props.valueKey]);
            } else {
              input.onBlur(input.value);
            }
          }}
          onFocus={this.props._onFocus}
          backspaceRemoves={false}
          value={value}
          valueKey={this.props.valueKey}
          options={this.props.options}
          placeholder={this.props.placeholder}
          clearable={this.props.clearable}
          onBlurResetsInput={false}
          onInputKeyDown={this.props.onKeyDown}
          tabSelectsValue
          onChange={ev => {
            if (this.props.onChange) {
              this.props.onChange(ev);
            }
            input.onChange(ev);
          }}
        />
        {meta.touched &&
          meta.error && (
            <ValidateError className={errorClassName} text={meta.error} />
          )}
      </div>
    );
  }
}
